import React from 'react';
import { createPortal } from 'react-dom';
import { RiCloseLine, RiDownloadLine } from 'react-icons/ri';

interface Props {
    url: string | null;
    isOpen: boolean;
    onClose: () => void;
}

export default function ResumePreviewModal({ url, isOpen, onClose }: Props) {
    if (!isOpen || !url) return null;

    return createPortal(
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
            <div className="w-full max-w-5xl h-[85vh] bg-[#0B0B0F] border border-white/10 rounded-2xl shadow-2xl flex flex-col relative overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b border-white/10 bg-white/5">
                    <h2 className="text-lg font-bold text-white">Resume Preview</h2>
                    <div className="flex items-center gap-3">
                        <a
                            href={url}
                            download
                            className="p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors"
                            title="Download"
                        >
                            <RiDownloadLine size={20} />
                        </a>
                        <button
                            onClick={onClose}
                            className="p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors"
                        >
                            <RiCloseLine size={22} />
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-neutral-900 relative">
                    <iframe
                        src={url}
                        className="w-full h-full border-0"
                        title="Resume Preview"
                    />
                </div>
            </div>
        </div>,
        document.body
    );
}
